import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { AppComponent } from '../../new/app.component';

angular
  .module('common')
  .directive('coApp', downgradeComponent({ component: AppComponent }));
